










































import _ from "lodash";
import { createComponent, computed, ref, watch } from "@vue/composition-api";
import { SummaryMethodParams } from "element-ui/types/table";

export interface TableColumnConfig {
  label: string;
  sortable?: boolean;
  formatter?: (value: any) => string;
  sortMethod?: (a: any, b: any) => number;
  getSummary?: () => any;
}
export interface TableConfig {
  [field: string]: TableColumnConfig;
}

interface Props {
  value: any[];
  columns: TableConfig;
  showSummary: boolean;
  getItemKey: (item: any) => any;
}

export default createComponent<Props>({
  components: {},
  props: {
    value: { required: true, type: Array },
    columns: { required: true, type: Object },
    showSummary: { default: false, type: Boolean },
    getItemKey: { default: _.identity, type: Function },
  },
  setup(props, ctx) {
    function getCellContent(
      fieldName: string,
      column: TableColumnConfig,
      row: any,
    ) {
      const fieldValue = _.get(row, fieldName);
      return column.formatter ? column.formatter(fieldValue) : fieldValue;
    }

    const isSelectable = computed(() => "selected-item-view" in ctx.slots);

    const getSummaries = ({ columns, data }: SummaryMethodParams) => {
      return columns.map((col: any) => {
        const summaryGetter =
          props.columns[col.property] && props.columns[col.property].getSummary;
        if (summaryGetter) return summaryGetter();
        return undefined;
      });
    };
    const selectedItem = ref<any>(null);

    function refreshSelectedItem() {
      const getKey = (x: any) => x && props.getItemKey(x);

      selectedItem.value =
        props.value.find((x) => getKey(x) === getKey(selectedItem.value)) ??
        null;
    }
    watch(() => props.value, refreshSelectedItem);

    function selectItem(item: any) {
      selectedItem.value = item;
    }

    function deselectItem() {
      selectedItem.value = null;
    }

    const classes = computed(() => {
      let result = "base-table";
      if (isSelectable) result += " selectable";
      return result;
    });

    return {
      classes,
      selectedItem,
      getCellContent,
      getSummaries,
      selectItem,
      isSelectable,
      deselectItem,
    };
  },
});
